import styles from "./card.module.scss";

const Card = ({ data }: any) => {
  return (
    <>
      <div className={styles["container"]}>
        <h2>{data.service}</h2>

        <p className={styles["service-tab-para"]}>{data.details}</p>
        <label className={styles["service-tab-rate"]}>{data.rate}</label>
      </div>
    </>
  );
};

export default Card;
